import React, { memo } from 'react';

import { Block } from '../../components/core';
import { TextFormatContent } from './text-format-content';
import { cn } from '@/lib/utils';

interface TextFormatBlockProps {
  id: string;
}

export const TextFormatBlock = memo(function InternalTextFormatBlock({ id }: TextFormatBlockProps) {
  return (
    <Block.Root id={id}>
      <div className={cn('relative')}>
        <Block.Content id={id}>
          <TextFormatContent id={id} />
        </Block.Content>
        <div className={cn('absolute top-[0.7rem] right-[0.7rem]')}>
          <Block.HeaderControls id={id} />
        </div>
      </div>
    </Block.Root>
  );
});
